module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var listService = require('ListService.js').default;
var sales = listService.salesEmailAddress;

    ; __append("\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-8 prop-sublabel form-group-flex\">\r\n        <input type=\"checkbox\" name=\"encrypt\" class=\"form-radio-group\"> \r\n        <label class=\"form-group-label\">Encrypt</label> \r\n    </div>\r\n</div>\r\n<div id=\"featureDisabled\" style=\"display: none; font-size: 14px;\">\r\n\r\n    The Encryption feature is not currently active on your account. \r\n    To learn more about enabling this feature please contact ")
    ; __append(escapeFn(sales ))
    ; __append(".\r\n\r\n</div>")
  }
  return __output;

}